<script setup lang="ts">
import { Button } from '~ds/components/ui/button';
import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

/**
 * The way back above a page, or an activity's overview, under the new information architecture: the
 * button in the bar's own column, with the same space above and below it on every page. The coach
 * shell's and the public layout's back buttons both draw it; each says where it goes and goes there.
 */
interface Props {
  label: string;
  testId: string;
}

defineProps<Props>();

const emit = defineEmits<{ back: [] }>();
</script>

<template>
  <div class="mx-auto w-full max-w-7xl px-4 py-8">
    <Button
      variant="outline"
      size="sm"
      class="w-fit"
      :data-testid="testId"
      @click="emit('back')"
    >
      <Icon
        :name="ICONS.arrowLeft2"
        size="xs"
        aria-hidden="true"
      />
      {{ label }}
    </Button>
  </div>
</template>
